import React from "react";
import { TableCell } from "@material-ui/core";
import { ArrowDownward, ArrowUpward } from "@material-ui/icons";
import { useStyles } from "./TableStyles";
import { getLogger } from "lib/util";

const log = getLogger("lib.components.Table.Column");

export function Column({
	columnIndex, caption, field,
	displayType, align, minWidth="140", maxWidth,
	sortedColumns, setSortedColumns,
	sortfield, sortDataType}) {
	let classes = useStyles();
	let domProps = {};
	if (align)
		domProps.align = align;
	let onClick, className = classes.headerSpan;
	let sortImage = getSortImage(classes, sortedColumns, columnIndex, field, sortfield);
	if (field == null)
		field = sortfield;
	if (field == null)
		className += " " + classes.noClick;
	else
		onClick = (event) => columnClicked(event, columnIndex, field, displayType, sortDataType, sortfield, sortedColumns, setSortedColumns);
	return (
		<TableCell className={classes.tableHeaderCell} {...domProps} style={{minWidth, maxWidth}}>
			<span className={className} onClick={onClick} >{caption}{sortImage}</span>
		</TableCell>
	);
}

function getSortImage(classes, sortedColumns, columnIndex, field, sortfield) {
	for (let i = 0; sortedColumns != null && i < sortedColumns.length; i++) {
		let isThisColumn = false;
		if (sortedColumns[i].columnIndex != null) {
			isThisColumn = sortedColumns[i].columnIndex === columnIndex;
    }
		else if (sortedColumns[i].field) {
			if (field) {
				isThisColumn = sortedColumns[i].field === field;
      }
			else if (sortfield) {
				isThisColumn = sortedColumns[i].field === sortfield;
      }
		}

		if (isThisColumn) {
			let arrow;
			if (sortedColumns[i].ascending === false)
				arrow = <ArrowDownward className={classes.sortArrow} />
			else
				arrow = <ArrowUpward className={classes.sortArrow}/>
			return <span>{arrow}<span className={classes.sortNumber}>{"" + (i + 1)}</span></span>
		}
	}
}

function columnClicked(event, columnIndex, field, displayType, sortDataType, sortfield, sortedColumns, setSortedColumns) {
	let sort = [...sortedColumns];
	log.debug("Clicked %o %o %o", columnIndex, field, sortfield);
	if (field == null && sortfield == null) {
		return;
  }
	let found = false;
	if (event.ctrlKey || sort.length === 1)
		for (let i = 0; sort != null && i < sort.length; i++) {
			if (sort[i].columnIndex === columnIndex) {
				found = true;
				sort[i].ascending = !sort[i].ascending;
			}
		}
  const sortByField = sortfield != null ? sortfield : field;
	if (found === false) {
		const def = {columnIndex: columnIndex, ascending: true, field: sortByField}
		if (displayType)
			def.dataType = displayType;
		if (sortDataType)
			def.dataType = sortDataType;
		log.debug("Add sort %o", def);
		if (event.ctrlKey)
			sort.push(def);
		else
			sort = [def];
	}
	log.debug("New sort %o", sort);
	setSortedColumns(sort);
}
